module.exports = __webpack_public_path__ + "/images/logo-hellowish-dark.a107a06.webp";